'use client';

import { useTranslation } from '@/hooks/useTranslation';
import type { DebtData } from '@/types';
import type { TransactionItem } from '@/types/core-api';
import { TransactionsList } from '../_shared/TransactionsList';

interface PaymentHistoryListProps {
  account: DebtData;
  transactions: TransactionItem[];
}

/** The cleared debt's payments. The debt itself is described by the breakdown above this, so an empty list shows nothing. */
export function PaymentHistoryList({ account, transactions }: PaymentHistoryListProps) {
  const { t } = useTranslation();
  if (transactions.length === 0) return null;
  return <TransactionsList transactions={transactions} title={t('transaction.transactions')} currency={account.currency} />;
}
